import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clear: () => null,
  asyncs: {
  }
}, 'cdPurchaseOrder');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
  },
  deleteObj: null,
  Actions: {
  },
  Columns: [
    { headerName: 'Priority', field: 'Priority', suppressSorting: true, minWidth: 150 },
    { headerName: 'Purchase order', field: 'PurchaseOrder', suppressSorting: true, minWidth: 150 },
    { headerName: 'Committed', field: 'CommittedQuantityDisplay', type: 'numericColumn', suppressSorting: true },
    { headerName: 'User ID', field: 'UserId', type: 'numericColumn', suppressSorting: true },
    { headerName: 'Due', field: 'DueDate', type: 'numericColumn' },
    { headerName: 'Order status', field: 'OrderStatus', suppressSorting: true },
    { headerName: 'Supplier', field: 'Supplier', suppressSorting: true },
    { headerName: 'Supplier name', field: 'SupplierName', suppressSorting: true },
  ],
  Data: [
  ]
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clear:
      return {
        ...state,
        data: {
          ...state.data,
          Data: []
        }
      }
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.salesOrderEnquiry.cdPurchaseOrder,
  {
    Data: data => data.Data,
    selected: data => data.selected,
    Actions: data => data.Actions,
  }
)

const syncSelector = {
  isLoading: state => state.salesOrderEnquiry.cdPurchaseOrder.loading,
  gridOptions: state => state.salesOrderEnquiry.cdPurchaseOrder.data.gridOptions,
  Columns: state => state.salesOrderEnquiry.cdPurchaseOrder.data.Columns,
  Actions: state => state.salesOrderEnquiry.cdPurchaseOrder.data.Actions,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)